export default "__VITE_ASSET__DjHkOmHi__"